import { FileType } from 'src/app/shared/model/file-type';

export interface ReportFileRequestParams extends Record<string, string | boolean> {
  viewState: string;
  reportTitle: string;
  titles: string;
  file_type: FileType;
  filename: string;
  summaries: string;
  cron: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'Accept-Language': string;
  archive?: boolean;
}

export class FileContent {
  filename: string;
}
